export const SESSION_INVALID_CODE = 501;

const SESSION_INVALID_MESSAGE_PATTERNS = [
  "session expired",
  "session invalid",
  "session expired or not found",
  "account has been blocked",
  "blocked by admin",
];

export const hasSessionInvalidMessage = (message) => {
  if (typeof message !== "string") return false;

  const normalizedMessage = message.toLowerCase();
  return SESSION_INVALID_MESSAGE_PATTERNS.some((pattern) =>
    normalizedMessage.includes(pattern)
  );
};

export const isSessionInvalidResponse = (data) =>
  data?.responseCode === SESSION_INVALID_CODE &&
  hasSessionInvalidMessage(data?.message);
